import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from '../../shared/components/table/table.component';
import { TableColumn } from '../../core/models/column.model';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { Alert } from '../../core/models/alert.model';

@Component({
  selector: 'app-alert-settings',
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    RouterModule,
  ],
  templateUrl: './alert-settings.component.html',
  styleUrl: './alert-settings.component.scss',
})
export class AlertSettingsComponent implements OnInit {
  alerts: Alert[] = [];
  flattenedData: any[] = [];

  tableColumns: TableColumn[] = [
    { header: 'Nº', field: 'id' },
    { header: 'Nombre', field: 'maintenanceType' },
    { header: 'Detalle', field: 'containerTypeName' },
    { header: 'Estado', field: 'username' },
    { header: 'Fecha', field: 'changeType' },
  ];

  constructor() {}

  ngOnInit(): void {}

  flattenData(): void {}
}
